<template>
  <div class="content">
    <div class="content-box renter-info">
      <renter-enterprise
         v-if="!renterId"
         :enterpriseType="enterpriseType"
          @change="onChangeEnterpriseType"
        ></renter-enterprise>
      <div class="content-box">
        <el-form :model="form" ref="form" label-width="150px" label-position="top">
          <div class="form-box">
            <p class="form-title">{{ $t('crm_renter_item_info_personal.ge_ren_xin_xi')}}</p>
              <el-row class="form-container">
               <el-col :span="12" class="form-container-left">
                <el-form-item
                  :label="$t('crm_renter_item_info_personal.gong_si_lei_xing')"
                  prop="partnerType"
                  :rules="rules.partnerType"
                >
                  <custom-select
                    v-model="form.partnerType"
                    code="bas_org_type"
                    width="350px"
                    :disabled="true"
                  ></custom-select>
                </el-form-item>
               </el-col>
               <el-form-item
                  :label="$t('crm_renter_item_info_personal.gong_si_bian_hao')"
                  prop="partnerCode"
                  :rules="erpCodeRequired?[]:rules.partnerCode"
                >
                  <el-input
                    v-model="form.partnerCode"
                    style="width:350px;"
                  ></el-input>
                </el-form-item>
              </el-row>
            <el-row class="form-container">
              <el-col :span="12" class="form-container-left">
                <el-form-item
                  :label="$t('crm_renter_item_info_personal.shou_ji_hao_ma')"
                  prop="telephone"
                  :rules="rules.telephone"
                >
                  <el-input
                    v-model="form.telephone"
                    style="width:350px;"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :label="$t('crm_renter_item_info_personal.ju_zhu_di_zhi')"
                  prop="address"
                  :rules="rules.address"
                >
                  <custom-address-select
                    :placeholder="$t('Common.com_please_select')"
                    v-model="form.address"
                    ref="address"
                    style="width: 350px;"
                  ></custom-address-select>
                </el-form-item>
                <el-form-item
                  :label="$t('crm_renter_item_info_personal.jzxxdz')"
                  prop="detailAddress"
                  :rules="rules.detailAddress"
                >
                  <el-input
                    type="textarea"
                    v-model="form.detailAddress"
                    style="width:350px;"
                  ></el-input>
                </el-form-item>

                <el-form-item
                  :label="$t('crm_renter_item_info_personal.miao_shu')"
                  prop="partnerDesc"
                  :rules="rules.partnerDesc"
                >
                  <el-input
                    type="textarea"
                    v-model="form.partnerDesc"
                    style="width:350px;"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="form-container-right">
              <el-form-item
                :label="$t('crm_renter_item_info_personal.shi_qu')"
                prop="timeZoneId"
                :rules="rules.timeZoneId"
                v-if="this.timeZoneList.length > 1"
              >
                <custom-select
                  v-model="form.timeZoneId"
                  :data="timeZoneList"
                  :auto="false"
                  :props="{ label: 'timeZoneRegionDesc', value: 'timeZoneId' }"
                  width="350px"
                ></custom-select>
              </el-form-item>
              <el-form-item
                  :label="$t('crm_renter_item_info_personal.you_xiang')"
                  prop="email"
                  :rules="rules.email"
                >
                  <el-input
                    v-model="form.email"
                    style="width:350px;"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="form-box">
            <p
              class="form-title"
            >{{ $t('crm_renter_item_info_personal.sfzxx') }}</p>
            <el-row class="form-container">
              <el-col :span="12" class="form-container-left">
                <el-form-item
                  :label="$t('crm_renter_item_info_personal.xing_ming')"
                  prop="legalPerson"
                  :rules="rules.legalPerson"
                >
                  <el-input
                    v-model="form.legalPerson"
                    style="width:350px;"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  :label="$t('crm_renter_item_info_personal.shen_fen_zheng_hao')"
                  prop="legalPersonIdentity"
                >
                  <el-input
                    v-model="form.legalPersonIdentity"
                    style="width:350px;"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="form-container-right">
                <el-form-item
                  :label="$t('crm_renter_item_info_personal.shen_fen_zheng')"
                  prop="imageIdFace"
                >
                  <el-row>
                    <file-upload
                      :text="$t('crm_renter_item_info_personal.sfzrxm')"
                      :contentStyle="{
                      width: '200px',
                      height: '120px',
                      'padding-top': '37px',
                      'background': '#F5F5F5',
                      float: 'left'
                    }"
                      v-model="imageIdFace"
                      ref="imageIdFace"
                      bizType="crm.id.face"
                      :bizId="partnerId"
                      :autoUpload="false"
                    ></file-upload>
                    <file-upload
                      :text="$t('crm_renter_item_info_personal.sfzghm')"
                      :contentStyle="{
                      width: '200px',
                      height: '120px',
                      'padding-top': '37px',
                      'background': '#F5F5F5',
                      float: 'right'
                    }"
                      v-model="imageIdReverse"
                      ref="imageIdReverse"
                      bizType="crm.id.reverse"
                      :bizId="partnerId"
                      :autoUpload="false"
                    ></file-upload>
                  </el-row>
                  <div
                    class="tips mt-6"
                  >{{$t('crm_renter_item_info_personal.qscqxdsfzzgsqdxbcg2M') }}</div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        type="primary"
        @click="saveInfo"
      >{{$t('crm_renter_item_info_personal.xybglyxx')}}</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
// import tUpload from '@/components/upload.vue';
import customAddressSelect from '@/components/customAddressSelect.vue';
import fileUpload from '@/components/singleFileUpload.vue';
import renterEnterprise from './renter_item_enterprise.vue';

export default {
  components: { fileUpload, customAddressSelect, renterEnterprise },
  props: {
    partnerId: [String, Number],
    enterpriseType: [String, Number], // 1-企业，2-个体工商户，3-事业单位，4-宗教活动场所，5-其他
    orgId: [String, Number],
  },
  data() {
    // 密码验证
    return {
      cascaderProps: {
        value: 'code',
        label: 'value',
      },
      // 营业执照
      imageLicense: [],
      // 身份证id正面
      imageIdFace: [],
      // 身份证反面
      imageIdReverse: [],
      form: {
        partnerName: '',
        partnerClass: '1',
        partnerCode: '',
        telephone: '',
        email: '',
        // partnerScale: '',
        address: '', // 自用不参与交互
        detailAddress: '',
        // website: '',
        // registeredCapital: '',
        // currencyUnit: '¥',
        legalPerson: '',
        legalPersonIdentity: '',
        partnerDesc: '',
        timeZoneId: '', // 总部时区
        partnerType: 'CS', // 总部 HQ 售后公司SC 总代理 JV 大客户CO 公司CS
        enterpriseType: '5', // 1-企业，2-个体工商户，3-事业单位，4-宗教活动场所，5-个人
        // 地址
        country: '',
        countryCode: '',
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',

        // 营业执照
        businessLicense: '',
        // 纳税人识别号
        buyerNumber: '',
        // 修改的
        extendId: '',

        imageLicense: false,
        imageIdFace: false,
        imageIdReverse: false,
        orgId: ''
        // 对公信息
        // depositBank: '',
        // depositNumber: '',
        // bankCode: '',
        // bankcardId: '' // 银行信息  id  编辑 用
      },
      timeZoneList: [],
      // 公司ID
      renterId: '',
      // ERP编号权限
      erpCodeRequired: false
    };
  },
  watch: {
    partnerId(val) {
      this.renterId = val || '';
      this.getCompanyDetail();
    },
    enterpriseType(val) {
      if (val) {
        this.form.enterpriseType = val;
      }
    },
    orgId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form.orgId = val;
        }
      }
    },
  },
  mounted() {
    // this.renterId = this.getJump('renterId');
    this.renterId = this.partnerId || '';
    this.form.enterpriseType = this.enterpriseType;
    this.getCompanyDetail();
    this.rules.telephone[1].validator = this.$mobilePhoneValidator;
    // 查字典
    this.getDictionary('cloud_erpCode_control', () => {
      this.erpCodeRequired = this.$searchSiteCodeFunction('cloud_erpCode_control');
    });
  },

  computed: {
    rules() {
      return {
        // 基本信息

        partnerType: {
          required: true,
          message: this.$t('crm_renter_item_info_personal.qxzgslx'),
        },
        timeZoneId: [
          {
            required: true,
            message: this.$t('crm_renter_item_info_personal.qing_xuan_ze_shi_qu'),
          },
        ],
        partnerCode: [
          {
            type: 'string',
            required: true,
            message: this.$t('crm_renter_item_info_personal.qtxgsbh'),
          },
          { max: 20, message: this.$t('Common.com_rules_length_max', [20]) },
        ],
        telephone: [
          {
            type: 'string',
            required: true,
            message: this.$t('crm_renter_item_info_personal.qtxsjhm'),
          },
          {
            validator: null,
            message: this.$t('crm_renter_item_info_personal.cdyz713gzf'),
          },
        ],
        email: [
          {
            type: 'email',
            required: true,
            message: this.$t('crm_renter_item_info_personal.qtxyx'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],

        address: [
          {
            required: true,
            type: 'array',
            message: this.$t('crm_renter_item_info_personal.qxzjzdz'),
          },
          // { max: 100, message: '长度最长100个字符' }
        ],
        detailAddress: [
          {
            type: 'string',
            required: true,
            message: this.$t('crm_renter_item_info_personal.qtxjzxxdz'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]) },
        ],

        legalPerson: [
          {
            required: true,
            message: this.$t('crm_renter_item_info_personal.qtxxm'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ],
        legalPersonIdentity: [
          {
            required: true,
            message: this.$t('crm_renter_item_info_personal.qtxsfzh'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]) },
        ], // 数字或字母
        partnerDesc: { max: 200, message: this.$t('Common.com_rules_length_max', [200]) },
        imageIdFace: {
          type: 'string',
          required: true,
          message: this.$t('crm_renter_item_info_personal.qscsfzzfm'),
        },
        imageIdReverse: {
          type: 'string',
          required: true,
          message: this.$t('crm_renter_item_info_personal.qscsfzghm'),
        },
      };
    },
  },
  methods: {
    getCompanyDetail: function () {
      if (!this.renterId) {
        this.getTimeZoneList(true);
        return;
      }
      this.$getJSON(apis.partnerInfo, { partnerId: this.renterId }).then(
        (res) => {
          if (res.code === 0) {
            const data = res.data;

            this.$setFormatData(this.form, data);
            this.form.address = [];
            if (data.countryCode) {
              this.form.address.push(data.countryCode);
            }
            if (data.provinceCode) {
              this.form.address.push(data.provinceCode);
            }
            if (data.cityCode) {
              this.form.address.push(data.cityCode);
            }
            // this.form.partnerClass = `${data.partnerClass}`;
            // this.form.currencyUnit = `${data.currencyUnit}`;
            this.form.partnerType = data.partnerType;
            // 数字转字符串
            // this.form.registeredCapital = +data.registeredCapital;
            // 营业执照
            // this.businessLicenseImageList = this.businessLicenseImageList || [];
            this.idImageList = this.idImageList || [];

            // this.$emit('syncEnterpriseType', res.data.enterpriseType);
            this.getTimeZoneList(false);
          }
        }
      );
    },
    onChangeEnterpriseType: function (num) {
      const enterpriseType = num || 1;
      this.$emit('input', enterpriseType);
    },
    // 获取时区列表
    getTimeZoneList: function (isInit) {
      this.$getJSON(apis.timeZoneGetCompanyList, { orgId: this.orgId }).then((res) => {
        this.timeZoneList = res.data;
        if (this.timeZoneList.length > 0 && isInit) {
          this.form.timeZoneId = this.timeZoneList[0].timeZoneId;
        }
      });
    },
    // 图片校验
    checkImg() {
      // if (this.imageLicense.length > 0) {
      //   this.form.imageLicense = 'imageLicense';
      // } else {
      //   this.form.imageLicense = null;
      // }
      if (this.imageIdFace.length > 0) {
        this.form.imageIdFace = 'imageIdFace';
      } else {
        this.form.imageIdFace = '';
      }
      if (this.imageIdReverse.length > 0) {
        this.form.imageIdReverse = 'imageIdReverse';
      } else {
        this.form.imageIdReverse = '';
      }
    },

    // 取消
    onCancel: function () {
      this.$emit('cancel');
    },
    // 保存基本信息
    async saveInfo() {
      await Promise.all([
        this.$refs.imageIdFace.submit(),
        this.$refs.imageIdReverse.submit()
      ]);
      this.checkImg();
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        // 赋值 国家城市镇区
        const addressMsg = this.$refs.address.getAddressMsg();
        this.$setFormatData(this.form, addressMsg);
        // 个人租赁方
        this.form.partnerName = this.form.legalPerson;
        this.form.businessLicense = this.form.buyerNumber = this.form.legalPersonIdentity;
        // this.form.buyerNumber = this.form.legalPersonIdentity;

        // 图片保存
        this.form.partnerInstructionList = [
          // ...this.imageLicense,
          ...this.imageIdFace,
          ...this.imageIdReverse,
        ];
        // 保存交互
        if (this.renterId) {
          // renterId 公司id  编辑要放进参数里面
          this.form.partnerId = this.renterId;
          this.$postJSON(apis.partnerUpdate, this.form).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.$t('Common.com_modify_success'),
                type: 'success',
              });
              this.$emit('success', 3);
              // this.jump('/customer/renter', { refresh: true }, true);
            }
          });
        } else {
          //
          this.$postJSON(apis.partnerAdd, this.form).then((res) => {
            this.$message({
              message: this.$t('Common.com_add_success'),
              type: 'success',
            });
            this.$emit('syncPartnerId', res.data.partnerId, res.data.partnerOrgId);
            this.$emit('success', 3);
            // this.jump('/customer/renter', { refresh: true }, true);
          });
        }
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss">
@import "../../../../style/colors.scss";
.renter-info {
  padding: 14px 24px 0;
  .form-box {
    margin-top: 35px;
    position: relative;
    border: 1px solid rgba(13, 154, 224, 0.3);
    padding: 34px 24px 24px;
    .form-container{
      width: 900px;
      display: flex;
      .form-container-left {
        width: 350px !important;
        margin-right:24px;
      }
      .form-container-right {
        width: 414px !important;
        flex: 0 0 414px;
      }
    }
    .form-title {
      font-size: 12px;
      font-weight: 600;
      color: rgba(13, 154, 224, 1);
      line-height: 20px;
      height: 20px;
      position: absolute;
      top: -10px;
      left: 16px;
      background: #ffffff;
      padding: 0 10px;
    }
    .tip {
      background: rgba(53, 184, 224, 0.15);
      border-radius: 2px;
      margin: 8px 0 24px;
      padding-left: 10px;
      .icon {
        color: #0d9ae0;
        font-size: 12px;
        margin-right: 10px;
      }
      span {
        line-height: 32px;
        color: #6c757d;
        font-size: 12px;
      }
    }
    .tips {
      color: #aeb5bd;
      font-size: 12px;
      line-height: 16px;
      margin-top: 6px;
    }
  }
  .form-box:first-of-type {
    margin-top: 0;
  }
}
</style>
